import React from 'react';
import { NINFA_MODELS, CATEGORY_OPTIONS } from '../../utils/capitolatoData';

const ConfigurationList = ({ configurations, activeConfigIndex, onEdit, onDelete, onAddNew }) => {
    if (configurations.length === 0) return null;

    const getModelLabel = (value) => {
        const model = NINFA_MODELS.find(m => m.value === value);
        return model ? model.label : value || '—';
    };

    const getCategoryLabel = (value) => {
        const cat = CATEGORY_OPTIONS.find(c => c.value === value);
        return cat ? cat.label : value || '—';
    };

    return (
        <div className="mb-6 bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden">
            <div className="px-4 py-3 bg-gray-50 border-b border-gray-200 flex items-center justify-between">
                <div className="flex items-center gap-2">
                    <svg className="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                    </svg>
                    <h3 className="text-sm font-semibold text-gray-800">
                        Configurazioni salvate ({configurations.length})
                    </h3>
                </div>
            </div>

            <div className="divide-y divide-gray-100">
                {configurations.map((config, index) => (
                    <div
                        key={index}
                        className={`px-4 py-3 flex items-center justify-between transition-colors ${
                            activeConfigIndex === index ? 'bg-red-50 border-l-4 border-l-red-500' : 'hover:bg-gray-50'
                        }`}
                    >
                        <div className="flex items-center gap-3 min-w-0">
                            <span className="flex-shrink-0 w-7 h-7 rounded-full bg-red-100 text-red-700 flex items-center justify-center text-xs font-bold">
                                {index + 1}
                            </span>
                            <div className="min-w-0">
                                <p className="text-sm font-medium text-gray-900 truncate">
                                    {getModelLabel(config.modelloNinfa)}
                                </p>
                                <p className="text-xs text-gray-500 truncate">
                                    {getCategoryLabel(config.categoria)}
                                    {config.prezzo ? ` — €${config.prezzo}/m` : ''}
                                </p>
                            </div>
                        </div>

                        <div className="flex items-center gap-1 flex-shrink-0 ml-2">
                            <button
                                type="button"
                                onClick={() => onEdit(index)}
                                className="p-1.5 text-gray-500 hover:text-red-600 hover:bg-red-50 rounded-md transition-colors"
                                title="Modifica"
                            >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                </svg>
                            </button>
                            <button
                                type="button"
                                onClick={() => onDelete(index)}
                                className="p-1.5 text-gray-500 hover:text-red-600 hover:bg-red-50 rounded-md transition-colors"
                                title="Elimina"
                            >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                </svg>
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ConfigurationList;
